import { Users, Sparkles, Handshake, BarChart2} from 'lucide-react';
import Card from '@/components/common/ui/Card';

const plans = [
    {
        title: "User-Centric Approach",
        description: "We prioritize the needs and behaviors of your users, creating designs that resonate and engage, leading to higher satisfaction and loyalty.",
        icon: Users,
    },
    {
        title: "Cutting-Edge Techniques",
        description: "Our team stays ahead of design trends and technological advancements, ensuring your product remains modern and effective.",
        icon: Sparkles,
    },
    {
        title: "Collaborative Process",
        description: "We work closely with you throughout the design process, incorporating your vision and feedback to create a final product that aligns with your brand identity.",
        icon: Handshake,
    },
    {
        title: "Data-Driven Decisions",
        description: "Utilizing user research and analytics, we make informed design choices that enhance usability and drive results.",
        icon: BarChart2,
    },
];

export default function OtherServices() {
    return (
        <section className="container pb-24 pt-20">
            <div className="text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-12">
                    Our Distinctive Design Features Visual Design
                </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}